export { default } from "./src/horizontal-divider";
export type { UniformHorizontalDividerProps } from "./src/horizontal-divider";
